import * as types from "./actionTypes";
import * as userApi from "../../api/userApi";
import { beginApiCall, apiCallError } from "./apiStatusActions";

export function loginUserSuccess(user) {
  return { type: types.LOGIN_USER, user };
}

export function createUserSuccess(user) {
  return { type: types.CREATE_USER_SUCCESS, user };
}

export function updateUserSuccess(user) {
  return { type: types.UPDATE_USER_SUCCESS, user };
}

export function reportOptimistic(eventId, userId, reason) {
  return { type: types.REPORT_OPTIMISTIC, eventId, userId, reason };
}

export function getUserProfile(accessToken) {
  console.log("getUserProfile");
  return function (dispatch) {
    dispatch(beginApiCall());
    return userApi
      .getUserProfile(accessToken)
      .then(user => {
        dispatch(loginUserSuccess(user));
        return user;
      })
      .catch(error => {
        dispatch(apiCallError(error));
        throw error;
      });
  };
}

export function saveUser(accessToken, user) {
  return function (dispatch) {
    dispatch(beginApiCall());
    return userApi
      .saveUser(accessToken, user)
      .then(() => {
        dispatch(updateUserSuccess(user));
        return user;
      })
      .catch(error => {
        dispatch(apiCallError(error));
        throw error;
      });
  };
}

export function deleteUser(accessToken) {
  return function (dispatch) {
    dispatch(beginApiCall());
    return userApi
      .deleteUser(accessToken)
      .then(() => {
        dispatch(updateUserSuccess(null));
        return true;
      })
      .catch(error => {
        dispatch(apiCallError(error));
        throw error;
      });
  };
}

export function report(accessToken, eventId, userId, reason) {
  return function (dispatch) {
        dispatch(reportOptimistic(eventId, userId, reason));
    return userApi.report(accessToken, eventId, userId, reason)
  };
}
